import { get, post, getExFile, postExFile } from "@utils/httpUtil";

// 获取账户信息
export function getBalanceInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/finance/balanceInfo`, data, config);
}
// 获取充值记录
export function getRechargeRecord(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/finance/coins/getRechargeRecord`, data, config);
}
// 充值
export function applyRechargeCoins(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/finance/applyRechargeCoins`, data, config);
}
// 获取冻结
export function getFrozenRecord(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/finance/getFrozenRecord`, data, config);
}
// 获取交易记录
export function getTransactionRecord(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/finance/getTransactionRecord`, data, config);
}
// 查询交易流水统计
export function accountSum(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/finance/accountSum`, data, config);
}
// 导出;
export function exportTransactionRecord(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return getExFile(`/finance/exportTransactionRecord`, data, config);
}
// 导出冻结;
export function exportFrozenRecord(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return getExFile(`/finance/exportFrozenRecord`, data, config);
}
// 导出冻结;
export function financeAccount(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/account`, data, config);
}
//获取结算列表
export function financeFindSettlementPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/findSettlementPage`, data, config);
}
//获取结算detail
export function financeFindSettlementDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/findSettlementDetail`, data, config);
}

// 导出结算列表
export function financeExportSettlementList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/community/finance/exportSettlementList`, data, config);
}
//获取结算列表
export function middleSp_getDictionaryList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`${process.env.VUE_APP_OPEN_WENWO_LINK}/middle-sp/basic/dict/getDictionaryList`, data, config);
}
// 导出充值记录
export function financeExportRechargeList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/community/finance/exportRechargeAndWithdrawPage`, data, config);
}
//获取充值记录列表
export function financeFindRechargePage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/findRechargePage`, data, config);
}
// 导出支出列表
export function financeExportDisburseList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/community/finance/exportDisburseList`, data, config);
}
//获取支出列表列表
export function financeFindDisbursePage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/findDisbursePage`, data, config);
}
// 导出提现记录
export function financeExportWithdrawList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/community/finance/exportWithdrawList`, data, config);
}
//获取提现记录列表
export function financeFindWithdrawPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/findWithdrawPage`, data, config);
}
// 导出奖励明细
export function financeExportRewardList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/community/finance/exportRewardList`, data, config);
}
//获取奖励明细列表
export function financeFindRewardPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/findRewardPage`, data, config);
}
// 导出待结算明细
export function financeExportWaitSettlementList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/community/finance/exportWaitSettlementList`, data, config);
}
//获取待结算明细列表
export function financeFindWaitSettlementPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/findWaitSettlementPage`, data, config);
}
//汇总查询订单明细
export function financeSumPageOrderDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/sumPageOrderDetail`, data, config);
}

//社区储备金账户-查询余额
export function financeReserveAccountGetReserveAccount(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/reserveAccount/getReserveAccount`, data, config);
}
//社区储备金账户-充值
export function financeReserveAccountRecharge(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/reserveAccount/recharge`, data, config);
}
//社区储备金账户-提现
export function financeReserveAccountWithdraw(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/reserveAccount/withdraw`, data, config);
}
//分页查询交易明细列表
export function findTransactionDetailPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/findTransactionDetailPage`, data, config);
}
// 导出交易明细
export function exportTransactionDetailPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/community/finance/exportTransactionDetailPage`, data, config);
}
// 财务管理业务级联选项
export function getBusinessTree(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/getBusinessTree`, data, config);
}
// 获取社区结算收入统计数据
export function findSettlementStatistics(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/findSettlementStatistics`, data, config);
}
// 获取社区预算账户统计信息
export function budgetAccountStat(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/budgetAccount/stat`, data, config);
}
// 分页查询预算账户列表
export function budgetAccountPageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/budgetAccount/pageList`, data, config);
}
// 创建社区预算账户
export function budgetAccountSave(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/budgetAccount/save`, data, config);
}
// 更新社区预算账户
export function budgetAccountUpdate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/budgetAccount/update`, data, config);
}
// 校验预算账户名称是否可用，true-可用，false-不可用
export function budgetAccountCheckAccountName(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/budgetAccount/checkAccountName`, data, config);
}
// 转入金额
export function budgetAccountRecharge(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/budgetAccount/recharge`, data, config);
}
// 转出金额
export function budgetAccountWithdraw(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/budgetAccount/withdraw`, data, config);
}
// 预算账户明细-分页查询收入支出列表
export function budgetAccountIncomeAndExpenseDetailPageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/budgetAccount/detail/incomeAndExpenseDetailPageList`, data, config);
}
// 预算账户明细-分页查询转入转出列表
export function budgetAccountRechargeAndWithdrawDetailPageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/budgetAccount/detail/rechargeAndWithdrawDetailPageList`, data, config);
}
// 预算账户明细-分页查询商业投放费用明细
export function budgetAccountDistributionTradeDetailPageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/advert/pageDistributionTrade`, data, config);
}
// 主账户-收入-预算账户转入
export function mainAccountRechargeFromBudgetAccount(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/mainAccountRechargeFromBudgetAccount`, data, config);
}
// 主账户-支出-预算账户充值
export function mainAccountRechargeToBudgetAccount(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/mainAccountRechargeToBudgetAccount`, data, config);
}
// 主账户--收入（营销活动）
export function mainAccountPromotionIncome(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/mainAccountPromotionIncome`, data, config);
}
// 奖励发放统计
export function rewardStatistic(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/rewardStatistic`, data, config);
}
// 充值、提现
export function findRechargeAndWithdrawPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/findRechargeAndWithdrawPage`, data, config);
}

// 收益账户-提现-查询社区待提现流水列表
export function financeApplyTrades(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/applyTrades`, data, config);
}
// 收益账户-提现-查询社区提现记录
export function financeListByPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/listByPage`, data, config);
}
// 收益账户-提现-查询社区提现记录-详情
export function communityApplyDetails(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/communityApplyDetails`, data, config);
}
// 收益账户-提现-查询社区提现记录-详情-总金额
export function communityApplyDetailTotal(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/finance/communityApplyDetailTotal`, data, config);
}
